export default "__VITE_ASSET__3fecf5e3__"